import React, { useState } from "react";

import PlatformTableComponent from "../../../../components/platformTableComponent/platformTableComponent";
import { getCurrentDateFormatted } from "../../../../utils/utils";
import FieldAssignmentsMapping, { visitAddressWithLoanProps } from "../fieldAssignmentsMapping/fieldAssignmentsMapping";
import { geoLoactionApis } from "../../../../utils/ApiURLs";
import { GetRequest } from "../../../../utils/api";
import { Col, Row } from "antd";


const VisitAssignmentsPlotting: React.FC = ({ }) => {

  const [coordinates, setCoordinates] = useState<visitAddressWithLoanProps[]>([]);
  const [startPoint, setStartPoint] = useState<any>({ lat: 17.516930000000002, lng: 78.34283 });
  const [isEcodeSelected, setIsEcodeSelected] = useState<Boolean>(false);
  const [showMapComponent, setShowMapComponent] = useState<Boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("Please select an ecode to render the visit directions.");

  const deafultLocation = {
    lat: 17.516930000000002,
    lng: 78.34283
  };

  const fetchUserLoginCoordinates = async (ecode: any, date:any) => {

      return GetRequest(`auth/platform/api/user-log-in-history?size=100&page=0&search=ecode:eq${ecode};creationDtm:ge${date}`).then((data:any) => {
        // Process the received data
        if (data.records && data.records.length > 0) {
          let record = data.records.find((r: any) => r.lat !== undefined && r.lng !== undefined);
          setErrorMessage("");
          if(record){
            return { lat: record?.lat, lng: record?.lng };
          }
        }
        setErrorMessage("Sorry!! We didnt find user's recent location");
        // TODO: for now keeping it as deafult
        return deafultLocation;
      })
      .catch(() => {
        // Handle any errors
        setErrorMessage("Failed to fetch selected ecode recent location to plot, please try again later!");
        return deafultLocation;
      });
  };

  const handleRerenderOfMapComponent = () => {
    setShowMapComponent(false);
    setTimeout(() => setShowMapComponent(true), 0); // Force a re-render by setting to false and back to true
  };

  // Function to check if a value is considered zero
  const isZero = (value: any) => {
    return value === 0 || value === null || value === undefined ||
      value === '' || value === false || Number.isNaN(value);
  }

  const getFilterValue = (appliedFilters: any, searchString: any, fieldId: string): any => {
    let ecodeFilter = appliedFilters?.find((f: any) => f.field === fieldId);
    if (ecodeFilter && ecodeFilter.value) {
      return ecodeFilter.value;
    }
    if (searchString) {
      let assignedToStartIndex = searchString.indexOf(fieldId);
      if (assignedToStartIndex >= 0) {
        assignedToStartIndex = assignedToStartIndex + fieldId.length + 3; // 3 extra characters to skip the criteria ex: :eq, :lk , :gt
        let ecodeWithExtraPostFix = searchString.substring(assignedToStartIndex); // ex: CTCM003;56
        let endIIndexOfEcode = ecodeWithExtraPostFix.indexOf(";");
        return ecodeWithExtraPostFix.substring(0, endIIndexOfEcode);
      }
    }
    return undefined;
  }

  const handleOnLoadingResponseFromServer = async (responseFromServer: any, appliedFilters: any, searchString: any) => {

    let ecode = getFilterValue(appliedFilters, searchString, "assignedTo");
    let selectedDate = getFilterValue(appliedFilters, searchString, "visitCallDate");
    if (ecode) {
      const latLang = await fetchUserLoginCoordinates(ecode, selectedDate??getCurrentDateFormatted());
      setStartPoint(latLang);
      setIsEcodeSelected(true);

      if (responseFromServer.records.length > 0) {
        let waypoints: visitAddressWithLoanProps[] = responseFromServer.records
          .map((record: any) => { return { lat: record.addressLatitude, lng: record.addressLongitude, visitAddress: record.visitAddress ?? "", loanNo: record.loanNo, customerName: record.customerName, status: record.visitStatus } })
          .filter((rec: any) => !isZero(rec.lat) && !isZero(rec.lng));

        setCoordinates([...waypoints]);
        setErrorMessage("");
      }else{
        setCoordinates([]);
        setErrorMessage("No Records found.");
      }
    } else {
      setIsEcodeSelected(false);
      setCoordinates([]);
      setErrorMessage("Please select an ecode to render the visit directions.");
    }

    handleRerenderOfMapComponent();

  }

  return (
    <div>

        <Row>
          <Col span={12} sm={24} lg={12}>
            <PlatformTableComponent
              bluePrintApi={geoLoactionApis.fosTodoForPlottingApi}
              searchApi={geoLoactionApis.fosTodoPlottingSearchFilterApi}
              title={"Field Assignments"}
              moduleCode={"geoLocationPlotting"}
              showSelectAllAction={false}
              onLoadingResponse={handleOnLoadingResponseFromServer}
              showResetAction={false}
            />
          </Col>

          <Col span={12} sm={24} lg={12}>
            {(showMapComponent && coordinates?.length > 0 && isEcodeSelected && (errorMessage === null || errorMessage === undefined || errorMessage === "")) ?
              <FieldAssignmentsMapping apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY!} startingPoint={startPoint} visitLocations={coordinates} />
              : <> {errorMessage} </>
            }
          </Col>
        </Row>
      
    </div>
  );
};

export default VisitAssignmentsPlotting;
